import { PremiumPreviewType } from '../store/schema/PremiumPreviewData';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getPremiumPreviewType(): PremiumPreviewType {
    if (isFeatureEnabled('mc-officeEditorUpsellSkittleBasedOnDate')) {
        return PremiumPreviewType.TimeBased;
    }
    if (isFeatureEnabled('mc-officeEditorUpsellSkittleBasedOnCount')) {
        return PremiumPreviewType.CountBased;
    }

    return PremiumPreviewType.BasicSkittle;
}
